import React,{ Fragment, Component} from 'react';
import {Link} from 'react-router-dom';
import Masonry from 'react-masonry-component';
import Header from './../../Layout/Header';
import FooterPremium from './../../Layout/FooterPremium';
import PageTitle from './../../Layout/PageTitle';
import {Pagination} from './BlogGrid';

//images/
import grid1 from './../../../images/banner/img1.jpg';
import grid2 from './../../../images/banner/img2.jpg';
import grid3 from './../../../images/banner/img3.jpg';
import grid4 from './../../../images/banner/img4.jpg';
import grid5 from './../../../images/banner/img1.jpg';
import grid6 from './../../../images/banner/img2.jpg';
import grid7 from './../../../images/banner/img3.jpg';
import grid8 from './../../../images/banner/img4.jpg';
import bgimg from './../../../images/bg-view.png';

const gridBlog =[
	{
		blogimage: grid1,
		date: "January 15, 2024",
		author: "Star Giga Team",
		title: "Goldcrest Dreams Tower A & B Construction Milestone Achieved",
		description: "We're excited to announce significant progress on Goldcrest Dreams Tower A and Tower B in Emirates City, Ajman. The construction has reached a major milestone with structural completion, bringing us closer to delivering exceptional residential spaces."
	},
	{
		blogimage: grid2,
		date: "December 20, 2023",
		author: "Star Giga Team",
		title: "Goldcrest Views Wins Best Developer Award at Cityscape Middle East",
		description: "Star Giga is proud to announce that Goldcrest Views Tower at JLT, Dubai has won the Best Developer award for design and quality in residential building category, recognizing our commitment to excellence."
	},
	{
		blogimage: grid3,
		date: "November 10, 2023",
		author: "Star Giga Team",
		title: "New Launch: Goldcrest Executive in Jumeira Lake Towers",
		description: "Discover our latest premium development, Goldcrest Executive, strategically located in Jumeira Lake Towers, Dubai. Experience luxury living with world-class amenities and modern design."
	},
	{
		blogimage: grid4,
		date: "October 5, 2023",
		author: "Star Giga Team",
		title: "Star Giga Community Event: Open House at Goldcrest Dreams",
		description: "Join us for an exclusive open house event at Goldcrest Dreams, Ajman. Tour our show units and learn about our innovative approach to community development and sustainable living."
	},
	{
		blogimage: grid5,
		date: "September 18, 2023",
		author: "Star Giga Team",
		title: "Sustainable Building Practices: Star Giga's Green Initiative",
		description: "Learn about Star Giga's commitment to sustainable construction practices, including energy-efficient systems, eco-friendly materials, and green building certifications across all our developments."
	},
	{
		blogimage: grid6,
		date: "August 22, 2023",
		author: "Star Giga Team",
		title: "Investment Opportunities in UAE Real Estate: Goldcrest Properties",
		description: "Explore the lucrative investment opportunities in UAE real estate with Star Giga's Goldcrest properties. Discover why our developments offer excellent returns and long-term value appreciation."
	},
];

// Masonry section
const masonryOptions = {                                          
    transitionDuration: 0
};

const imagesLoadedOptions = { background: '.my-bg-image-el' }
// Masonry section end

class BlogMasonry extends Component{
	render(){
		return(
			<Fragment>
				<Header />
				<div className="page-content bg-white">
					<PageTitle motherMenu="Blogs" activeMenu="Blogs" />
					{/*  Inner Page Banner */}
					<section className="content-inner">				
						<div className="container">
							<div className="" id="masonry" data-column-width="10">
								<Masonry
									className={'my-gallery-class'} // default ''
									options={masonryOptions} // default {}
									disableImagesLoaded={false} // default false
									updateOnEachImageLoad={false} // default false and works only if disableImagesLoaded is false
									imagesLoadedOptions={imagesLoadedOptions} // default {}
								>
									{gridBlog.map((data,index)=>(
										<div className="card-container col-md-6 col-lg-4 col-sm-12 mb-5" key={index}>
											<div className="dlab-card blog-grid">
												<div className="dlab-media" style={{height: '250px', overflow: 'hidden'}}>
													<img 
														src={data.blogimage} 
														alt="" 
														style={{
															width: '100%',
															height: '100%',
															objectFit: 'cover',
															display: 'block'
														}}
													/>
												</div>
												<div className="dlab-info">
													<div className="dlab-meta">
														<ul>
															<li className="post-date"><i className="las la-calendar-alt"></i><span>{data.date}</span></li>
															<li className="post-user"><i className="las la-user"></i>By <Link to={"#"}>{data.author}</Link></li>
														</ul>
													</div>
													<h3 className="dlab-title">
														<Link to={"/blog-details"}>{data.title}</Link>
													</h3>
													<p>{data.description}</p>
													<div className="dlab-readmore">
														<Link to={"/blog-details"} className="readmore"><i className="las la-plus"></i> Read More</Link>
													</div>
												</div>
											</div>
										</div>
									))}
								</Masonry>
							</div>
							<nav aria-label="Page navigation example">
								<Pagination />
							</nav>
						</div>
					</section>
					<div>				
						<img src={bgimg} className="bg-view" alt=""/>
					</div>
				</div>
				<FooterPremium />
			</Fragment>
		)	
	}
}
export default BlogMasonry;